import * as React from "react";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

export interface InputBorderlessProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hasContent?: boolean;
  error?: string;
  required?: boolean;
}

export const InputBorderless = React.forwardRef<
  HTMLInputElement,
  InputBorderlessProps
>(({ label, hasContent, error, required, className, ...props }, ref) => {
  const baseInputStyles = cn(
    "bg-transparent w-full outline-none text-lg rounded-lg",
    "placeholder:text-tertiary-text placeholder:text-lg",
    "disabled:cursor-not-allowed disabled:text-tertiary-text",
    "focus:outline-none",
  );

  const placeholderWithAsterisk = required ? `${label} *` : label;

  return (
    <div className="relative">
      {hasContent && (
        <Typography
          variant="subtitleW3"
          className={cn(
            "absolute left-4 top-2 z-20 text-tertiary-text",
            error && "text-destructive",
          )}
        >
          {placeholderWithAsterisk}
        </Typography>
      )}
      <input
        ref={ref}
        className={cn(
          baseInputStyles,
          "h-14 px-4",
          hasContent && "pt-6",
          className,
        )}
        placeholder={placeholderWithAsterisk}
        required={required}
        {...props}
      />
    </div>
  );
});

InputBorderless.displayName = "InputBorderless";
